var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListSelector',{attrs:{"value":_vm.value,"params":_vm.params,"headers":_vm.headers,"title":_vm.title,"expandible":false,"service":"Actions"},on:{"input":function($event){return _vm.$emit('input',$event)}},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_vm._v(" "+_vm._s(item.title)+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }